const clearHtmlTags = html => html?.replace(/<[^>]*>?/gm, '');

export default clearHtmlTags;
